
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/taxonomies/[taxonomy]/[...slug]",
      function () {
        return require("private-next-pages/taxonomies/[taxonomy]/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/taxonomies/[taxonomy]/[...slug]"])
      });
    }
  